module.exports = __webpack_public_path__ + "static/media/image-qualidade.51c6b0ca.png";